export function buildWizardRequestHeaders(
  defaults: Headers,
  body?: BodyInit | null,
  overrides?: HeadersInit
): Headers {
  const headers = new Headers(defaults)
  new Headers(overrides).forEach((value, key) => headers.set(key, value))

  if (body == null || (typeof FormData !== 'undefined' && body instanceof FormData)) {
    // Body-less requests must not invoke Fastify's JSON parser, while the
    // browser must supply the multipart boundary for FormData requests.
    headers.delete('Content-Type')
  } else if (typeof body === 'string' && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json')
  }

  return headers
}
